export default {
  termsAndConditionsOpen: true,
  gamesLegalLines: [],
  updateBingoLobbyFeed: {},
  updateStateModal: { open: false, data: null }
}
